import { computed } from "vue";
import { useMutation, useQuery, useQueryClient } from "@tanstack/vue-query";
import type { CreateCouponInput } from "@phurshell/psiapp-frontend-core/domain";
import { couponRepo } from "@/di/repositories";

export function useCouponList() {
  const { data, isPending } = useQuery({
    queryKey: ["coupons", "list"],
    queryFn: () => couponRepo.getCoupons({ page: 1 }),
  });
  return { coupons: computed(() => data.value ?? []), isPending };
}

export function useInvalidateCoupons() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: ["coupons"] });
}

export function useCreateCoupon() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: CreateCouponInput) => couponRepo.createCoupon(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["coupons"] });
    },
  });
}

export function useDeleteCoupon() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => couponRepo.deleteCoupon(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["coupons"] });
    },
  });
}
